<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4.43698 10.5695C4.15319 12.7404 3.9808 14.9463 3.92573 17.1813C6.94238 18.4408 9.81157 19.9829 12.5002 21.7747C15.1888 19.9829 18.058 18.4408 21.0746 17.1813C21.0196 14.9463 20.8472 12.7404 20.5634 10.5696M4.43698 10.5695C3.52479 10.2629 2.60153 9.98039 1.66797 9.72271C5.04858 7.35309 8.67457 5.30969 12.5002 3.63818C16.3259 5.30969 19.9519 7.3531 23.3325 9.72272C22.3989 9.98041 21.4756 10.2629 20.5634 10.5696M4.43698 10.5695C7.23619 11.5104 9.93122 12.6781 12.5002 14.0508C15.0692 12.6781 17.7642 11.5104 20.5634 10.5696M7.03143 15.6251C7.46291 15.6251 7.81268 15.2753 7.81268 14.8439C7.81268 14.4124 7.46291 14.0626 7.03143 14.0626C6.59996 14.0626 6.25018 14.4124 6.25018 14.8439C6.25018 15.2753 6.59996 15.6251 7.03143 15.6251ZM7.03143 15.6251V11.7964C8.79339 10.7017 10.6185 9.69901 12.5002 8.7952M5.20085 20.8258C6.42124 19.6054 7.03143 18.0059 7.03143 16.4064V14.8439"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgGraduate',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
